<template>
  <v-autocomplete rounded dense single-line auto-select-first
                  hide-details hide-no-data return-object
                  :data-qa="dataQa"
                  :value="selectedStaff"
                  :items="staffs"
                  class="simple-picker"
                  item-text="display_name"
                  item-value="uid"
                  v-bind="$attrs"
                  v-on="$listeners"
                  @input="staff => $emit('staffSelected', staff)">
    <template #selection="{item, attrs, on}">
      <v-list-item dense v-bind="attrs" v-on="on"
                   class="simple-picker__selected"
                   :key="item.uid">
        <VcAvatar size="x-sm"
                  :colorId="item.color_id"
                  :imagePath="item.photo_path || ''"
                  :name="item.display_name"
                  :data-qa="`${dataQa}-${item.display_name}-avatar`"/>
        <span>{{item.display_name}}</span>
      </v-list-item>
    </template>
    <template #item="{item, attrs, on}">
      <v-list-item dense  v-bind="attrs" v-on="on"
                   class="simple-picker__item"
                   :key="item.uid">
        <VcAvatar size="x-sm"
                  :colorId="item.color_id"
                  :imagePath="item.photo_path || ''"
                  :name="item.display_name"
                  :data-qa="`${dataQa}-${item.display_name}-avatar`"/>
        <span>{{item.display_name}}</span>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'SimpleStaffPicker',
  directives: {ClickOutside},
  props: {
    staffs: {
      type: Array,
      required: true,
      validator: staffs => staffs.filter(staff => staff.uid && staff.display_name)
    },
    selectedStaff: {
      type: Object,
      required: true,
      validator: staff => staff.uid && staff.display_name,
    },
    dataQa: {
      type: String,
      default: 'SimpleStaffPicker'
    }
  },
  model: {
    prop: 'selectedStaff',
    event: 'staffSelected',
  },
  data() {
    return {
      filterStaff: this.staffs,
    }
  },
}
</script>

<style scoped lang="scss">
.simple-picker {
  &__item, &__selected {
    display: flex;
    align-items: center;
    gap: var(--size-value2);
  }

  &__selected {
    padding: 0;
    min-height: var(--size-value6);
  }

  ::v-deep {
    .v-input__append-inner .v-icon {
      margin-top: 0 !important;
    }
  }
}
</style>
